/**
 * @typedef {Object} InputValidatorInterface
 * @property {(value:string, containerElement?: HTMLFormElement) => {isValid:boolean, message?: string}} validate
 * @property {(value:string, containerElement?: HTMLFormElement) => string} maskValue
 */
/**
 * @type {Record<string, InputValidatorInterface>}
 */
const InputValidatorController = {
	'cpf-cnpj': {
		validate(value, containerElement) {
			const cleanValue = value.replace(/\D/g, '');
			const validCpf = validarCPF(cleanValue);
			const validCnpj = validarCNPJ(cleanValue);

			return cleanValue.length <= 11 ? validCpf : validCnpj;
		},
		maskValue(value, containerElement) {
			const cleanValue = value.replace(/\D/g, '').slice(0, 14);
			const maskedCpf = formatarCPF(cleanValue);
			const maskedCnpj = formatarCNPJ(cleanValue);

			return cleanValue.length <= 11 ? maskedCpf : maskedCnpj;
		}
	},
	email: {
		maskValue(value, containerElement) {
			return value.replace(/ /g, '');
		},
		validate(email) {

			// Expressão regular para validar o formato do e-mail
			const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (!email || !regexEmail.test(email)) {
				return {
					isValid: false,
					message: 'Por favor, insira um endereço de e-mail válido.'
				};
			}
			return {
				isValid: true,
			};


		}
	},

	'confirm-email': {
		maskValue(value, containerElement) {
			return value.replace(/ /g, '');
		},
		validate(value) {
			// Expressão regular para validar o formato do e-mail
			const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (!value || !regexEmail.test(value)) {
				return {
					isValid: false,
					message: 'Por favor, insira um endereço de e-mail válido.'
				};
			}
			// GET THE FIRST EMAIL HERE
			const targetEmail = document.getElementById('field-email').value;

			return {
				isValid: `${targetEmail}`.toLowerCase() == `${value}`.toLowerCase(),
				message: 'Os e-mails não conferem, tente novamente.'
			};
		}
	},
	phone: {
		maskValue(phone) {
			return phone
				.replace(/\D/g, '')
				.slice(0, 11)
				.replace(/(\d{2})(\d{1,5})(\d{4})/, '($1) $2-$3');
		},
		validate(phone) {
			phone = phone.replace(/\D/g, '');
			const phoneDDD = phone.slice(0, 2);
			const DDDisValid = !!BrasilStates[String(phoneDDD)];

			if (!DDDisValid)
				return {
					isValid: false,
					message: 'DDD inválido, tente novamente.'
				};

			return {
				isValid: phone.length >= 10,
				message: 'Número de telefone inválido'
			};
		}
	},
	'complete-name': {
		maskValue(name) {
			let maskname = name
				.replace(/[0-9.,\/#@!$%\^&\*;:{}=\-_`~()]/g, '')
				.replace(/  /g, ' ');

			if (maskname[0] == ' ') maskname = maskname.slice(1, maskname.length);
			return maskname;
		},
		validate(name) {
			const splitedName = name.split(' ');
			return {
				isValid:
					splitedName.length > 1 &&
					splitedName[0].length > 0 &&
					splitedName[1].length > 0,
				message: 'O sobrenome é obrigatório'
			};
		}
	},
	'date-startat': {
		maskValue(value, containerElement) {
			return value;
		},
		validate(value, containerElement) {
			const endAtValue = document.getElementById('field-date-endat')?.value;
			
			const endDate = new Date(endAtValue);
			const targetDate = new Date(value);
			const startOfferDate = new Date('01/20/2024');
			const currentDate = new Date();


			if (targetDate == 'Invalid Date') {
				return {isValid: false, message: 'Data inválida, tente novamente.'};
			}

			if (targetDate < startOfferDate) {
				return {
					isValid: false,
					message: `A data selecionada está fora da vigência da campanha: de 21/1 a 16/4/24`
				};
			}

			if (targetDate > currentDate) {
				return {
					isValid: false,
					message:
						'A data de início deve ser quando houve a interrupção, tente novamente.'
				};
			}

			if (targetDate > endDate) {
				return {
					isValid: false,
					message: 'Selecione uma data inicial anterior à data final'
				};
			}

			return {isValid: true, message: ''};
		}
	},
	'date-endat': {
		maskValue(value, containerElement) {
			return value;
		},
		validate(value, containerElement) {
			const startAtValue = document.getElementById('field-date-startat')?.value;

			const startDate = new Date(startAtValue);
			const targetDate = new Date(value);
			const endOfferDate = new Date('04/16/2024');
			const currentDate = new Date();

			if (targetDate == 'Invalid Date') {
				return {isValid: false, message: 'Data inválida, tente novamente.'};
			}
			if (targetDate > endOfferDate) {
				return {
					isValid: false,
					message: `Parece que a data selecionada está fora da vigência da campanha`
				};
			}
			if (targetDate > currentDate) {
				return {
					isValid: false,
					message:
						'A data de termino deve ser quando retornou da interrupção, tente novamente.'
				};
			}
			if (targetDate < startDate) {
				return {
					isValid: false,
					message: 'Selecione uma data final posterior à data inicial'
				};
			}

			return {isValid: true, message: ''};
		}
	}
};
